import { ChangeDetectionStrategy, Component, computed, inject, OnInit, Signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { OshTreeComponent } from '@app/components/osh/osh-tree/osh-tree.component';
import { ActiveCompanyService } from '@app/shared/services/active-company.service';
import { CompanyOshAnalysisDataService } from '@app/shared/services/company-osh-analysis-data.service';
import { DialogService } from '@app/shared/services/shared/dialog.service';
import { Company } from '@app/shared/types/models/company/company.model';
import { CreateOrEditOshAnalysisDialogData } from '@app/shared/types/models/osh/osh.model';
import { UiPageWrapperComponent } from '@app/shared/ui/page-wrapper/ui-page-wrapper.component';
import { UiSpinnerDirective } from '@app/shared/ui/spinner/ui-spinner.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-company-osh-view',
  imports: [MatIconModule, OshTreeComponent, UiPageWrapperComponent, TranslatePipe, UiSpinnerDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './company-osh-view.component.html'
})
export class CompanyOshViewComponent implements OnInit {
  private readonly dialogService: DialogService = inject(DialogService);
  private readonly activeCompanyService: ActiveCompanyService = inject(ActiveCompanyService);
  private readonly companyOshAnalysisDataService: CompanyOshAnalysisDataService = inject(CompanyOshAnalysisDataService);

  protected readonly getCompanyOshAnalyses = computed(() =>
    this.companyOshAnalysisDataService.getCompanyOshAnalyses(this.activeCompany()?.id)()
  );
  protected activeCompany: Signal<Company | undefined> = this.activeCompanyService.activeCompany;

  public ngOnInit(): void {
    this.companyOshAnalysisDataService.loadCompanyOshAnalyses(this.activeCompany()?.id);
  }

  protected openCreateOshAnalysisDialog(): void {
    this.dialogService
      .openCreateOshAnalysisDialog({ id: this.activeCompany()?.id })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.companyOshAnalysisDataService.addCompanyOshAnalysis(this.activeCompany()?.id, result);
          this.companyOshAnalysisDataService.loadCompanyOshAnalyses(this.activeCompany()?.id);
        }
      });
  }

  protected editOshAnalysis(result: CreateOrEditOshAnalysisDialogData): void {
    this.companyOshAnalysisDataService.editCompanyOshAnalysis(this.activeCompany()?.id, result);
    this.companyOshAnalysisDataService.loadCompanyOshAnalyses(this.activeCompany()?.id);
  }

  protected deleteOshAnalysis(analysisId: string): void {
    this.companyOshAnalysisDataService.deleteOshAnalysis(this.activeCompany()?.id, analysisId);
    this.companyOshAnalysisDataService.loadCompanyOshAnalyses(this.activeCompany()?.id);
  }
}
